module.exports = __webpack_public_path__ + "img/authorization-vip.a86da745.svg";